export default function ErrorPage() {
  return (
    <main className="mx-auto max-w-[85rem] px-8 py-4">
      <h3 className="my-2 font-serif text-2xl font-bold italic text-(--themered)">
        Terribly Sorry
      </h3>
      <p className="my-2">
        If you got here by clicking a link, then that link is broken.
      </p>
      <p className="my-2">
        If something else happened, well... there&#8217;s been a website error
        either way.
      </p>
      <p className="my-2">
        <span className="text-lg italic">Please,</span> let us know. Thank you.
      </p>
      <p className="mx-4 my-2">&mdash; EVTCC</p>
    </main>
  );
}
